import React, { useEffect, useState } from "react";
import { SpecializationEffect } from "../../../appRedux/doctor/sagas/effects/SpecailizationEffect";
import DoctorSelectBox from "./DoctorSelectBox";

const SpecializationSelector = ({
  placeholder = "Select Specialization",
  label = "",
  rules = [],
  name,
  editMode,
  margin = "mb-0",
}) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    getStatusList();
  }, []);

  const getStatusList = async () => {
    try {
      const { data } = await SpecializationEffect();
      const specList = data?.data;
      let options = specList.map((row) => ({
        label: row.Name,
        value: row.id,
      }));
      setOptions(options);
    } catch (error) {
      setOptions([]);
    }
  };

  return (
    <DoctorSelectBox
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
    />
  );
};

export default SpecializationSelector;
